import { render, staticRenderFns } from "./BatchTicket.vue?vue&type=template&id=722206bc&scoped=true"
import script from "./BatchTicket.vue?vue&type=script&lang=js"
export * from "./BatchTicket.vue?vue&type=script&lang=js"
import style0 from "./BatchTicket.vue?vue&type=style&index=0&id=722206bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722206bc",
  null
  
)

export default component.exports